import React, { useState, useEffect } from 'react';
import api from '../api';

function Recommendations({ email, onViewMou }) {
  const [recommendations, setRecommendations] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const res = await api.get('/api/recommendations', { params: { email } });
        setRecommendations(res.data);
      } catch (err) {
        console.error('Failed to load recommendations', err);
        setError('Could not load recommendations');
      } finally {
        setLoading(false);
      }
    };

    if (email) {
      fetchRecommendations();
    }
  }, [email]);

  if (loading || error || !recommendations || !recommendations.mous || recommendations.mous.length === 0) {
    return null; // hide entirely if loading, error, or empty
  }

  const { mous } = recommendations;

  return (
    <div style={{ marginBottom: '20px' }}>
      <h3 style={{ 
        padding: '16px 16px 8px 16px', 
        margin: 0, 
        fontSize: '14px', 
        color: '#5f6368',
        fontWeight: '600',
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }}>
        Recommended for you
      </h3>
      
      <div style={{ borderTop: '1px solid #f0f0f0', borderBottom: '1px solid #f0f0f0' }}>
        {mous.map(mou => (
          <div 
            key={mou.prefix} 
            className="mou-row active"
            onClick={() => onViewMou && onViewMou(mou.prefix)}
          >
            <div className="mou-info" style={{ marginLeft: '12px' }}>
              <div className="mou-primary">
                <span className="partner-name">
                  {mou.partner_name || mou.title || 'Unknown Partner'}
                </span>
              </div>
              <div className="mou-secondary">
                <span className="mou-id" title={mou.prefix}>
                  {mou.prefix}
                </span>
              </div>
            </div>
            
            <span className="status-badge active">
              ✨ Recommended
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Recommendations;
